import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'formatMinutes' })
export class FormatMinutesToDaysOrHours implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    const min = value;
    const m = min % 60;
    const h = (min - m) / 60;
    const d = (min - min % (60 * 24)) / (60 * 24);

    if (d > 0) {
      return d.toString() + ' days';
    }
    else if (h > 0) {
      return h.toString() + ' hours';
    }
    else {
      return Math.floor(m).toString() + ' minutes';
    }

  }
}
